import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import type { IncidentsResponse } from 'apis/incidents/incidents_response_type';
import { getIncidents } from 'apis/incidents/search';
import layoutHeader from './_styles/layout/header.module.scss';
import { IncidentsArea } from './IncidentsArea';

type SignInHeaderProps = {
  hasHeaderLink?: boolean;
};

export const SignInHeader = ({ hasHeaderLink = true }: SignInHeaderProps) => {
  const [incidents, setIncidents] = useState<IncidentsResponse[]>([]);
  const apiCalledRef = useRef(false);

  useEffect(() => {
    // See: https://github.com/reactwg/react-18/discussions/18#discussion-3385714
    if (apiCalledRef.current === false) {
      apiCalledRef.current = true;
      getIncidents().then((response) => {
        if (response.status === 200) setIncidents(response.data.incidents);
      });
    }
  });

  return (
    <>
      <header className={layoutHeader['l-header']} id="header-area">
        <div className={layoutHeader['l-header-left']}>
          {hasHeaderLink ? (
            <Link href="/" className={layoutHeader['l-logo']}>
              <Image
                alt=""
                src="/images/logo-white.png"
                width={130}
                height={31}
              />
            </Link>
          ) : (
            <div className={layoutHeader['l-logo']}>
              <Image
                alt=""
                src="/images/logo-white.png"
                width={130}
                height={31}
              />
            </div>
          )}
        </div>
      </header>
      <IncidentsArea incidents={incidents} />
      <style>
        {`
        .c-nav-lists-layout {
          margin-left: 10px;
          padding-top: 16px;
        }

        .c-nav-overlay-hidden {
          display: none;
        }

        .c-nav-overlay-is-open {
          display: block;
        }

        .c-nav-sub-hidden {
          max-height: 0;
          overflow: hidden;
        }

        .c-nav-sub-is-open {
          transition: max-height ease-in 0.5s;
          max-height: 100vh;
          overflow: auto;
        }
      `}
      </style>
    </>
  );
};
